var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBalanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318986"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624116",
    x: 0.4,
    y: 5.60923,
    width: 19.2,
    height: 13.5659,
    rx: 3.6,
    stroke: "#5063C0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624117",
    d: "M13.733 12.4916C13.733 11.1017 14.8598 9.97495 16.2497 9.97495H19.5997V15.0083H16.2497C14.8598 15.0083 13.733 13.8815 13.733 12.4916Z",
    stroke: "#5063C0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 662",
    d: "M9.79395 5.57015L13.8356 3.45142",
    stroke: "#5063C0",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 986",
    cx: 16.2496,
    cy: 12.4918,
    r: 0.849593,
    stroke: "#5063C0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66872 5.76816L11.8324 1.58321C13.9618 0.491602 16.4921 2.03794 16.4921 4.43084V5.76816H17.2921V4.43084C17.2921 1.43971 14.1292 -0.493208 11.4674 0.871298L1.91504 5.76816H3.66872ZM7.30198 19.5747L14.2921 19.5748C14.2992 19.5748 14.3064 19.5748 14.3135 19.5747H7.30198Z",
    fill: "#5063C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBalanceIcon);
export default __webpack_public_path__ + "static/media/header-balance-icon.2c30ff07b6defa16d2bd133e621e0a98.svg";
export { ForwardRef as ReactComponent };